/* eslint-disable react/jsx-pascal-case */
import React from 'react';
import Asset from '../Asset/Asset';

const FiftyFifty = ({ children, title }) => (
  <>
    {title && <Asset id={title} />}
    <div className="row">
      <div className="col-md-6 col-sm-12">
        {children.length ? children[0] : children}
      </div>
      <div className="col-md-6 col-sm-12">
        {children.length ? children[1] : null}
      </div>
    </div>
  </>
);

const Col2_40_60 = ({ children, title }) => (
  <>
    {title && <Asset id={title} />}
    <div className="row">
      <div className="col-md-4 col-sm-12">
        {children.length ? children[0] : children}
      </div>
      <div className="col-md-8 col-sm-12">
        {children.length ? children[1] : null}
      </div>
    </div>
  </>
);

const Full = ({ children, title }) => (
  <>
    {title && <Asset id={title} />}
    <div className="row">
      <div className="col-md-12">{children}</div>
    </div>
  </>
);

const ChunkLayout = ({ layout, children, header }) => {
  switch (layout) {
    case 'col2-40-60':
      return <Col2_40_60 title={header}>{children}</Col2_40_60>;
    case 'fifty-fifty':
      return <FiftyFifty title={header}>{children}</FiftyFifty>;
    case 'full':
      return <Full title={header}>{children}</Full>;
    default:
      return <Col2_40_60 title={header}>{children}</Col2_40_60>;
  }
};
export default ChunkLayout;
